export default __webpack_public_path__ + "static/media/application-screenshots-02.25179fc9.jpg";